// Angular
import { Inject, Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

// Local library
import { AccountFacade } from '@amwager/account/data-access';
import { CommonFacade, ENVIRONMENT } from '@amwager/data-access';
import { MatNotificationService } from '@amwager/util';

// Local file
import { FundingFacade } from '../+state';
import { FundingService } from './funding.service';

/** Business logic for the withdraw online-check (ACH) component. */
@Injectable()
export class WithdrawOnlineCheckService {

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly fundingFacade: FundingFacade,
    private readonly accountFacade: AccountFacade,
    private readonly commonFacade: CommonFacade,
    private readonly matNotificationService: MatNotificationService,
    private readonly fundingService: FundingService,
    @Inject(ENVIRONMENT) private readonly environment: string,
  ) {}

  /** Build the online-check form. */
  buildForm(): FormGroup {
    return this.formBuilder.group({
      amount: ['', [Validators.required]]
    });
  }

  /** Account balance stream. */
  balance$() {
    return this.accountFacade.getBalance$();
  }

  /** Current TMS id stream. */
  tmsId$() {
    return this.commonFacade?.tmsId$();
  }

  /** Load the saved ACH accounts. */
  loadAccounts$() {
    this.fundingFacade.getAchAccount();
    return this.fundingFacade.getAchAccountList$();
  }

  /** Dispatch the ACH withdrawal and stream the result. */
  withdraw$(amount: number, accountId: string, tmsId?: string) {
    this.fundingFacade.withdrawOnlineCheck(amount, accountId, tmsId);
    return this.fundingFacade.isWithdrawOnlineCheckSuccess$();
  }

  /** Flag the app as offline for the given source. */
  setOffline(source: string): void {
    this.commonFacade.setIsConnectedInternet(source, false);
  }

  /** Mark all controls touched to reveal validation messages. */
  markFormGroupTouched(formGroup: FormGroup): void {
    this.fundingService.markFormGroupTouched(formGroup);
  }

  /** Show a single-button alert. */
  showAlert(header: string, message: string): void {
    this.matNotificationService.showAlert(header, message, undefined, undefined, 'Close');
  }

  /** Watch connectivity and report changes back to the caller. */
  checkConnectivity(source: string, onChange: (online: boolean) => void): void {
    this.fundingService.checkConnectivity(this.environment, source, onChange);
  }

}
